



export default function InfoPrice({customCoin,title,isLoading,teterPriceSell,teterPriceBuy,coinBy='IR'}){




    return(

        <div className="cardinfopp">

            <div className="d-flex itemrrr">
                <div className="item7979">
                    <div className="titinghgur224">
                        قیمت خرید

                    </div>

                    <div className="djisuyegg66613 text-buy">
                    {new Intl.NumberFormat("fa").format(customCoin['sell'])!='ناعدد' && !isLoading ?

                                    <>
                                        {title == 'USDT' ? 
                                        <>
                                        {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['buy'])}
                      
                                        </>
                                        :
                                        <>
                                        {coinBy == 'IR'?
                                            new Intl.NumberFormat("fa",{maximumFractionDigits:customCoin['buyIrt']>10000 ? 3 : 8}).format(customCoin['buyIrt'] )


                                        :

                                        new Intl.NumberFormat("fa",{maximumFractionDigits:customCoin['sell']>1 ? 3 : 13}).format(customCoin['sell'] )
                                        
                                        
                                        }


                                       

                                        </>
                                    }
                                    </>
                                    :
                                    <>

                                    -----

                                    
                     



                                    </>
                                        }

<div className="teecjfitoman13">
                            {coinBy == 'USDT'? 

                            <>تتر</>

                            :

                            <>تومان</>
                            }
                        
                            </div>


                      
                    </div>

                </div>

                
                

                <div className="item7979">
                    <div className="titinghgur224 ">
                    قیمت فروش 
                    </div>

                    <div className="djisuyegg66613 text-sell">


                    {new Intl.NumberFormat("fa").format(customCoin['sell'] * teterPriceSell)!='ناعدد' && !isLoading ?

<>
     {title == 'USDT' ? 
        new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['sell'] )

        :
<>
                                        {coinBy == 'IR'?
                                            new Intl.NumberFormat("fa",{maximumFractionDigits:customCoin['sellIrt']>10000 ? 3 : 8}).format(customCoin['sellIrt'] )


                                        :

                                        new Intl.NumberFormat("fa",{maximumFractionDigits:customCoin['buy']>1 ? 3 : 13}).format(customCoin['buy'] )
                                        
                                        
                                        }


                                       

                                        </>    }

     

</>
 :
 <>


 -----



 </>
}
                    <div className="teecjfitoman13">
                            {coinBy == 'USDT'? 

                            <>تتر</>

                            :

                            <>تومان</>
                            }
                            </div>
                   
                   
                    </div>

                </div>

            

                <div className="item7979">
                    <div className="titinghgur224">
                    بالاترین قیمت
                    </div>

                    <div className="djisuyegg66613">


                        
                    {new Intl.NumberFormat("fa").format(customCoin['high'] )!= 'ناعدد'  && !isLoading?

    new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['high'])
    
:
<>

-----

 </>
     }
                        <div className="teecjfitoman13">
                        تتر
                            </div>
                    </div>

                </div>


               

                <div className="item7979">
                    <div className="titinghgur224">
                    پایین ترین قیمت
                    </div>

                    
                    <div className="djisuyegg66613 ">
                    {new Intl.NumberFormat("fa").format(customCoin['low'] )!= 'ناعدد' && !isLoading ?

    new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['low'])
    
:
<>

-----

 </>
     }
                        <div className="teecjfitoman13">
                        تتر
                            </div>
                    </div>

                </div>

            </div>

         
        
        
        </div>
    )
}